import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import s from "./ErrorFallBack.module.scss";
export default function ErrorFallBack() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    // Errors from thrown Response objects
    return (
      <div>
        <h1>{error.status}</h1>
        <p>{error.statusText}</p>
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>Something went wrong 😢</h1>
      <pre className={s.errorMessage}>{(error as Error).message}</pre>
    </div>
  );
}
